import { UseLoadingReturn } from "@/hooks/use-loading";
import useRemove from "@/hooks/use-remove";
import workflowService from "@/services/workflow.service";
import { RemoveByIdProps } from "@/types/requests.types";

export type UseRemoveUserReturn = {
  removeWorkflow: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveWorkflow = (): UseRemoveUserReturn => {
  const {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    remove: removeWorkflow,
  } = useRemove({
    operation: (workflowId) => workflowService.delete(workflowId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    removeWorkflow,
  };
};

export default useRemoveWorkflow;
